<router-outlet></router-outlet>

<p-toast
  [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
  position="bottom-right"
></p-toast>
